"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var errors_1 = require("../errors");
var InternalArchiteture_error_1 = __importDefault(require("../errors/InternalArchiteture.error"));
function handleAxiosReponseError(error) {
    var response = error.response;
    if (response === null || response === void 0 ? void 0 : response.data.type) {
        var type = response.data.type;
        var data = response.data;
        var status_1 = response.status;
        if (type === errors_1.ERRORS.ACCESS_DENIED)
            throw new errors_1.AccessDeniedError(data, status_1);
        if (type === errors_1.ERRORS.BAD_REQUEST)
            throw new errors_1.BadRequestError(data, status_1);
        if (type === errors_1.ERRORS.BUSINESS_LOGIC)
            throw new errors_1.BusinessLogicError(data, status_1);
        if (type === errors_1.ERRORS.CONFLICT)
            throw new errors_1.ConflictError(data, status_1);
        if (type === errors_1.ERRORS.INTEGRATION_ERROR)
            throw new errors_1.IntegrationError(data, status_1);
        if (type === errors_1.ERRORS.INTERNAL_ARCHITECTURE)
            throw new InternalArchiteture_error_1.default(data, status_1);
        if (type === errors_1.ERRORS.INVALID_TOKEN)
            throw new errors_1.InvalidTokenError(data, status_1);
        if (type === errors_1.ERRORS.LIST_NOT_FOUND)
            throw new errors_1.ListNotFoundError(data, status_1);
        if (type === errors_1.ERRORS.METHOD_NOT_ALLOWED)
            throw new errors_1.MethodNotAllowedError(data, status_1);
        if (type === errors_1.ERRORS.NO_CONTENT)
            throw new errors_1.NoContentError(data, status_1);
        if (type === errors_1.ERRORS.PARAMETER)
            throw new errors_1.ParameterError(data, status_1);
        if (type === errors_1.ERRORS.RESOURCE_NOT_FOUND)
            throw new errors_1.ResourceNotFoundError(data, status_1);
        if (type === errors_1.ERRORS.UNSUPPORTED_MEDIA_TYPE)
            throw new errors_1.UnsuppotedMediaTypeError(data, status_1);
    }
    throw new errors_1.GenericError({
        description: (response === null || response === void 0 ? void 0 : response.data.description) || error.message || "Erro Desconhecido",
        notifications: (response === null || response === void 0 ? void 0 : response.data.notifications) || [response === null || response === void 0 ? void 0 : response.data.description] || ["Erro Desconhecido"],
        type: (response === null || response === void 0 ? void 0 : response.data.type) || "GenericError",
    }, response === null || response === void 0 ? void 0 : response.status);
}
exports.default = handleAxiosReponseError;
